import { Injectable } from "@angular/core";
import { HttpService } from "src/app/session/services/http.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class EmbeddedDashboardService {
  constructor(private httpService: HttpService) {}

  public async getReportData(reportValue: string): Promise<any> {
    const url = `${environment.webApiUrl}/api/embeddedreports/getreport/${reportValue}`;
    return this.httpService.get(url, { withCredentials: true }).toPromise();
  }
}
